import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { publicRoutes, appRoutes } from "routes";
import 'react-multi-carousel/lib/styles.css';
import 'react-range-slider-input/dist/style.css';
import 'react-day-picker/dist/style.css';
import AppRoute from "routes/router";

function App() {
  return (
    <div className="font-poppins h-full">
      <Router>
        <Routes>
          {publicRoutes.map((item, key) => (
            <Route key={key} element={item.element} path={item.path} />
          ))}
          <Route element={<AppRoute />}>
            {appRoutes.map((item, key) => (
              <Route key={key} element={item.element} path={item.path} exact={item.exact} />
            ))}
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
